<template lang='html'>
  <section class='test-entry'>
    <section class='test_content'>
      <div class='test_content_info'>
        <span>{{stepTitle}}</span>
        <p>{{stepDescription}}</p>
        <p>In the sentences, some words have their letters missing. Choose the right word from the options given.</p>
      </div>
      <question v-for='question in questions' :question='question' :key='question.id' @onAnswer='handlerAnswer'></question>
    </section>
  </section>
</template>

<script>
import axios from 'axios';
import Question from './Question';

export default {
  name: 'step',

  props: {
    stepTitle: {
      type: String
    },
    stepDescription: {
      type: String
    },
    questions: {
      type: Array,
      default: function() {
        return []
      }
    }
  },

  data() {
    return {
      answers: this.questions,
      isValidate: false
    }
  },

  watch: {
    answers: {
      handler(answers) {
        let stepCompleted = answers.every( (el) => {
          return !!el.answer;
        });

        if(stepCompleted && !this.isValidate) {
          this.$emit('onCompleteStep', () => this.answers);
          this.isValidate = true;
        };
      },
      deep: true
    }
  },

  methods: {
    handlerAnswer({ question }) {
      const index = this.answers.findIndex(item => item.id === question.id);
      this.answers[index] = question;
    }
  },

  components: {Question},

  mounted() {
  }
}
</script>

<style lang='scss'>
  $blue: #00bcc6;
  $orange: #f7941d;

  .test_blue {
    color: $blue;
  }

  .test-entry {
    margin: 0px auto;
    max-width: 710px;
    width: 100%;
    font: 300 16px/25px 'Fira Sans', sans-serif;
  }

  .test-entry_top-img {
    width: 100%;
    vertical-align: bottom;
  }

  .test_content {
    width: 100%;
    background-color: #f5fbfb;
    color: #555555;
    padding: 40px 0 0 0;
  }

  .test_content_title {
    text-align: center;
    font-size: 30px;
    line-height: 35px;
    color: $blue;
    padding-bottom: 30px;
    margin: 0 40px;
  }

  .test_content > p {
    margin: 0px 6% 25px 6%;
    text-align: justify;
  }

  .test_content_wish {
    font-size: 18px;
    font-weight: 400;
  }

  .test_content_title2 {
    font-size: 30px;
    line-height: 30px;
    padding-left: 15px;
    margin: 40px 5% 0 5%;
    border-left: 3px solid $orange;
    font-weight: 400;
  }

  .test_content_info {
    margin: 0 5% 20px 5%;
    padding: 20px;
    border: 1px solid $blue;
    border-style: dashed;
    font-size: 18px;
  }

  .test_content_info > span {
    display: block;
    color: $blue;
    text-transform: uppercase;
    font-weight: 400;
  }

  .test_button {
    display: block;
    cursor: pointer;
    text-align: center;
    font-size: 30px;
    margin: 0 5%;
    background-color: lightgrey;
    padding: 15px 0 12px 0;
    border-radius: 5px;
    border-bottom: 3px solid rgba(0, 0, 0, 0.3);
    transition: 0.3s;
  }

  .test_button:hover {
    opacity: 0.8;
    text-decoration: none;
  }

  .test_button_active {
    background-color: #fff003;
    text-decoration: none;
  }

  .test_bottom-img {
    width: 100%;
    vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// src/components/Step.vue